import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.items,"label":_vm.$t('Tax Type'),"outlined":"","hide-details":"auto","item-text":"text","item-value":"value"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }